(function () {
  'use strict';

  var WISH_COLOR = '#f1bfbc';
  var ACTIVE_FILLS = ['#000000', '#000', 'rgb(0, 0, 0)', 'rgb(0,0,0)'];

  function normalizeColor(value) {
    return (value || '').replace(/\s/g, '').toLowerCase();
  }

  function isActiveFill(value) {
    if (!value || value === 'none') return false;
    return ACTIVE_FILLS.indexOf(normalizeColor(value)) !== -1;
  }

  function paintActiveWishlistIcon(button) {
    var svg = button.querySelector('svg');
    var path = svg && svg.querySelector('path');
    if (!svg) return;

    var svgFill = svg.getAttribute('fill');
    var pathFill = path && path.getAttribute('fill');
    var active = isActiveFill(svgFill) || isActiveFill(pathFill);

    if (!active) return;

    svg.setAttribute('fill', WISH_COLOR);
    svg.setAttribute('stroke', WISH_COLOR);

    if (path) {
      path.setAttribute('fill', WISH_COLOR);
      path.setAttribute('stroke', WISH_COLOR);
    }
  }

  function observeWishlistButton(button) {
    if (button.dataset.mrwCardStyled === 'true') return;
    button.dataset.mrwCardStyled = 'true';

    paintActiveWishlistIcon(button);

    var observer = new MutationObserver(function () {
      paintActiveWishlistIcon(button);
    });

    observer.observe(button, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['fill', 'stroke', 'style'],
    });
  }

  function scanWishlistButtons() {
    document
      .querySelectorAll('.card-wrapper mrw-wishlist-card-button, .card-wrapper mrw-wishlist-product-card')
      .forEach(observeWishlistButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanWishlistButtons);
  } else {
    scanWishlistButtons();
  }

  window.addEventListener('load', scanWishlistButtons);

  if (document.body) {
    new MutationObserver(scanWishlistButtons).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
